import type { ReactNode } from 'react';
import { createRoot, type Root } from 'react-dom/client';

const roots = new WeakMap<Element | DocumentFragment, Root>();

export const renderReactRoot = (
  container: Element | DocumentFragment,
  content: ReactNode
) => {
  let root = roots.get(container);

  if (root == null) {
    root = createRoot(container);
    roots.set(container, root);
  }

  root.render(content);
};
